import Tooltip from '@codegouvfr/react-dsfr/Tooltip';
import React, { PropsWithChildren, RefObject } from 'react';
import { FaCircleInfo } from 'react-icons/fa6';
import { useCheckFormSchema } from './hooks/use-check-form-schema.hook';
import { useFormFieldParams } from './hooks/use-form-field-params.hook';

export const FormField = ({
                            name,
                            title,
                            type,
                            placeholder,
                            inputRef,
                            children,
                            id,
                            onChange,
                            hidden,
                            accept,
                            className,
                            min,
                            max,
                            forceRequiredIndicator,
                            tooltip,
                          }: FormFieldProps) => {
  useCheckFormSchema({ name });

  const { inputProps, error, isRequired, isReadonly } = useFormFieldParams({ name });

  return (
    <div className={'form-field ' + (className ?? '')} style={{ display: hidden ? 'none' : '' }}>
      {(title) && (
        <label className={'flex gap-1'} htmlFor={name}>
          {title} {(forceRequiredIndicator ?? isRequired) && <label>*</label>}
          {(tooltip) && (
            <Tooltip title={tooltip!} kind="hover">
              <FaCircleInfo className={'color-primary'} />
            </Tooltip>
          )}
        </label>
      )}

      {(error?.message) && (
        <span className={'error-message'}>{error?.message}</span>
      )}

      <input
        {...inputProps}
        id={id ?? `input-${name}`}
        accept={accept?.join(',')}
        style={{ backgroundColor: isReadonly ? '#eaeaea' : '' }}
        className={'form-field-input'}
        placeholder={!isReadonly ? (placeholder ?? '') : ''}
        type={type ?? 'text'}
        hidden={hidden ?? false}
        ref={(ev) => {
          inputProps.ref(ev);
          if (inputRef) inputRef.current = ev;
        }}
        onChange={(ev) => {
          onChange?.(ev);
          inputProps.onChange(ev).then();
        }}
        readOnly={isReadonly ?? false}
        disabled={isReadonly ?? false}
        min={min}
        max={max}
      />

      {children}
    </div>
  );
};

export interface FormFieldProps extends PropsWithChildren {
  name: string,
  title?: string,
  type?: string,
  placeholder?: any,
  inputRef?: RefObject<HTMLInputElement>,
  onChange?: (ev: any) => void;
  hidden?: boolean,
  id?: string,
  accept?: string[],
  className?: string,
  min?: number | string;
  max?: number | string;
  forceRequiredIndicator?: boolean;
  tooltip?: string;
}